<template>
  <div>
    <div class="overflow-hidden">
      <div class="float-left" style="width: 128px; overflow-y: auto">
        <div
          class="pt-6"
          :style="
            store.getters.getConfig.is_header
              ? 'min-height: calc(100vh - 135px)'
              : 'min-height: calc(100vh - 115px)'
          "
        >
          <Menu :selectedKeys="[2]"></Menu>
        </div>
      </div>
      <div class="float-right" style="width: calc(100% - 128px)">
        <div class="p-6 pb-0">
          <a-alert
            v-if="info.review == 1"
            message="审核中"
            class="w-1/2"
            type="warning"
            show-icon
          />
          <a-alert
            v-if="info.review == 3"
            message="驳回意见"
            class="w-1/2"
            :description="info.review_reason"
            type="error"
            show-icon
          />
          <a-alert
            v-if="info.review == 2"
            message="认证成功"
            class="w-1/2"
            type="success"
            show-icon
          />
        </div>
        <a-anchor :offsetTop="64">
          <div class="p-6 bg-white border-b border-gray-200 border-solid">
            <a-button type="primary" v-if="disabled" @click="disabled = false" icon="form">
              {{ info.review == 2 ? '修改个人信息' : '修改' }}</a-button
            >
            <template v-else>
              <a-button v-if="info.id > 0" type="default" @click="cancel" class="mr-4" icon="undo"
                >取消修改</a-button
              >
              <a-button type="primary" @click="submit" icon="save" :loading="btnLoading">
                提交</a-button
              >
            </template>
            <a-button type="primary" class="ml-4" @click="visible = true"> 修改密码 </a-button>
          </div>
        </a-anchor>
        <a-spin :spinning="spinning">
          <div :style="{ width: '500px' }" class="pt-6">
            <a-form :form="form" v-bind="formItemLayout">
              <a-form-item label="昵称">
                <a-textarea
                  v-decorator="[
                    'name',
                    {
                      rules: [{ required: !disabled, message: '请输入昵称' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <!-- <a-form-item label="身份证人像面">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'id_card',
                      {
                        rules: [{ required: !disabled, message: '请上传身份证人像面' }],
                      },
                    ]"
                  ></a-input>
                  <Upload :disabled="disabled" :src="info.id_card" @upload="cardUpload"></Upload>
                </div>
              </a-form-item>
              <a-form-item label="身份证国徽面">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'id_card_back',
                      {
                        rules: [{ required: !disabled, message: '请上传身份证国徽面' }],
                      },
                    ]"
                  ></a-input>
                  <Upload
                    :disabled="disabled"
                    :src="info.id_card_back"
                    @upload="cardBackUpload"
                  ></Upload>
                </div>
              </a-form-item> -->
              <!-- <a-form-item label="开户行">
                <a-textarea
                  v-decorator="[
                    'bank_name',
                    {
                      rules: [{ required: false, message: '请输入开户行' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="银行账号">
                <a-textarea
                  v-decorator="[
                    'bank_account',
                    {
                      rules: [{ required: false, message: '请输入银行账号' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item> -->
            </a-form>
          </div>
        </a-spin>
      </div>
    </div>
    <PasswdForm
      :phone="info.phone_number"
      :id="info.id"
      :visible="visible"
      @cancel="visible = false"
    ></PasswdForm>
  </div>
</template>
<script>
  import Menu from '@/views/admin/menu/index.vue';
  import Upload from '@/components/Upload/index';
  import { userinfo, idCardOcr, user_info } from '@/api/user';
  import { pick } from 'lodash';
  import PasswdForm from './module/passwdForm.vue';
  import store from '@/store/index';
  export default {
    components: { Menu,PasswdForm },
    data() {
      return {
        info: {},
        disabled: false,
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        form: this.$form.createForm(this, { name: 'company' }),
        spinning: false,
        btnLoading: false,
        visible: false,
        store: store,
      };
    },
    activated() {
      this.getInfo();
    },
    watch: {
      info(a) {
        if (a.id) {
          setTimeout(() => {
            this.form.setFieldsValue(a);
          }, 10);
          this.disabled = true;
        } else {
          this.disabled = false;
          setTimeout(() => {
            this.form.resetFields();
          }, 10);
        }
      },
    },
    methods: {
      async getInfo() {
        this.spinning = true;
        this.info = (await userinfo()) || {};
        this.spinning = false;
      },
      async cardUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ id_card: res.pathname }), 1);
          this.info.id_card = res.pathname;
          this.info.id_card_id = res.id;
          let ocrres = await idCardOcr({ id: res.id, side: 'front' });
          let ocrrespick = pick(ocrres, [
            'province',
            'city',
            'district',
            'address',
            'id_card_num',
            'birthday',
            'sex',
            'name',
            'id_card_id',
          ]);
          this.info = Object.assign({}, this.info, ocrrespick);
          setTimeout(() => this.form.setFieldsValue({ name: ocrres.name }), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      async cardBackUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ id_card_back: res.pathname }), 1);
          this.info.id_card_back_id = res.id;
          this.info.id_card_back = res.pathname;
        } catch (error) {
          this.$message.error(error);
        }
      },
      async submit(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            try {
              this.spinning = true;
              this.btnLoading = true;
              let data = Object.assign(this.info, values);
              await user_info(data);
              this.$store.dispatch('user/getUserInfoAction');
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.getInfo();
              this.spinning = false;
              this.btnLoading = false;
            }
          }
        });
      },
      async cancel() {
        await this.getInfo();
        this.disabled = true;
      },
    },
  };
</script>
